/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/jsx-no-bind */
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import AssociatedAssets from '../../../common/sections/associatedAssets';
import withJobActions from './withJobActions';
const JobAssetsSubsection = props => {
  const active = props.active,
    onJobAdd = props.onJobAdd,
    onJobRemove = props.onJobRemove,
    onJobChange = props.onJobChange;
  const handleAdd = useCallback(asset => {
    const defaultData = () => ({
      jobID: active.id,
      assetID: asset.id,
      name: asset.name
    });
    return onJobAdd('assets', defaultData(asset));
  }, [active.id, onJobAdd]);
  const handleRemove = useCallback(index => onJobRemove('assets', index), [onJobRemove]);
  const handleChange = useCallback((index, name, value) => onJobChange("assets[".concat(index, "]/").concat(name), value), [onJobChange]);
  return /*#__PURE__*/React.createElement(AssociatedAssets, {
    className: "t-ja-assets",
    assets: active.assets,
    onChange: handleChange,
    onRemove: handleRemove,
    onAdd: handleAdd
  });
};
JobAssetsSubsection.propTypes = {
  active: PropTypes.shape({
    id: PropTypes.string,
    assets: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  onJobChange: PropTypes.func.isRequired,
  onJobRemove: PropTypes.func.isRequired,
  onJobAdd: PropTypes.func.isRequired
};
export { JobAssetsSubsection as UncomposedJobAssociatedAssetsSubsection };
export default withJobActions(JobAssetsSubsection);